
const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[700px] md:min-h-[900px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/13ba50602d2a90c4068b5cc8ee1e325a.jpeg"
          alt="İzmir'de profesyonel tadilat ve dekorasyon hizmetleri"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-bold text-white leading-tight mb-6">
            İzmir Tadilat Firması
          </h1>

          {/* Subheading */}
          <p className="text-base md:text-xl lg:text-2xl text-white/90 mb-8 md:mb-10 leading-relaxed">
            12+ yıllık deneyimimizle yaşam alanlarınızı estetik, fonksiyonel ve değerli hale getiriyoruz.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-4">
            <a
              href="/iletisim"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-wood hover:bg-wood-dark text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-sm md:text-base"
            >
              Ücretsiz Keşif
            </a>
            <a
              href="/hizmetler"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-sm md:text-base"
            >
              Hizmetlerimiz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
